<!--
     <Field field='QUnitField*'>

     Automaticly detects the file type and represent its.

     Good practices for this to work:
       - The fields components must be responsive
-->

<template>
  <span
    v-if="navigate"
    @click.stop="clicked"
    class="explorer-table-navigation-component"
    :disabled="disabled"
    :class="[disabled ? 'disabled-field' : '']"
  >
    <component
      v-bind:is="component_type"
      :field="field"
      v-if="field"
      :unit="unit"
      :short="short"
      :is_mobile="is_mobile"
      :disabled="disabled"
      :hide_avatar="hide_avatar"
      @download-evidence="handleEvidence"
    ></component>
  </span>
  <span v-else>
    <component
      v-bind:is="component_type"
      :field="field"
      v-if="field"
      :unit="unit"
      :short="short"
      :is_mobile="is_mobile"
      :disabled="disabled"
      :hide_avatar="hide_avatar"
      @download-evidence="handleEvidence"
    ></component>
  </span>
  
</template>

<style lang="scss">
.explorer-table-navigation-component span{
  color:blue;
  cursor: pointer !important;
}
.disabled-field span{
  color: black !important;
  cursor: default !important;
}
</style>

<script>
 import FieldString from './FieldString.vue';
 import FieldDate from './FieldDate.vue';
 import FieldImage from './FieldImage.vue';
 import FieldLink from './FieldLink.vue';
 import FieldFile from './FieldFile.vue';
 import FieldStringArea from './FieldStringArea.vue';
 import FieldState from './FieldState.vue';
 import FieldVersionableFile from './FieldVersionableFile.vue';
 import FieldIndicatorTracking from './FieldIndicatorTracking.vue';
 import FieldRelated from './FieldRelated.vue';
 import FieldCentro from './FieldCentro.vue';
 import FieldIndicatorRiskInterpretation from './FieldIndicatorRiskInterpretation.vue';
 import FieldUser from './FieldUser.vue';

 export default {
   name: 'Field',

   props: {
      'unit': {default: () => ({})},
      'field': {required: true},
      'short': {type: Boolean, default: false},
      'navigate': {type: Boolean, default: false},
      'is_mobile': {type: Boolean, default: false},
      'disabled': Boolean,
      'hide_avatar': Boolean,
   },

   components: {
     FieldString,
     FieldDate,
     FieldImage,
     FieldLink,
     FieldFile,
     FieldStringArea,
     FieldState,
     FieldVersionableFile,
     FieldIndicatorTracking,
     FieldRelated,
     FieldCentro,
     FieldIndicatorRiskInterpretation,
     FieldUser,
   },

   computed: {
     component_type() {
       return this.field.component();
     },

     a() {
      return {...this.field}
     }
   },

   methods:{
    handleEvidence(){
      this.$emit("download-evidence", this.field)
    },

     clicked(){
      this.$emit("navigate_to")
    }
   }
 };
</script>
